<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import IoMdClose from "svelte-icons/io/IoMdClose.svelte";
import "smelte/src/tailwind.css";
import MdClose from "svelte-icons/md/MdClose.svelte";
import MdMenu from "svelte-icons/md/MdMenu.svelte";
import Footer from "./components/Footer.svelte";
import Link from "./components/Link.svelte";
import Logging from "./components/Logging.svelte";

import Navbar from "./components/Navbar.svelte";
import Popup from "./components/Popup.svelte";
import PopupReleaseNotes from "./components/ReleaseNotesPopup.svelte";
import ChatTab from "./routes/chat/+page.svelte";
import FAQ from "./routes/faq/+page.svelte";
import LandingPage from "./routes/landingpage/+page.svelte";
import PrivacyPolicy from "./routes/privacypolicy/+page.svelte";
import RechercheTab from "./routes/rag/+page.svelte";
import SummaryTab from "./routes/summary/+page.svelte";
import TermsOfUse from "./routes/termsofuse/+page.svelte";

import FeedbackButtons from "./components/FeedbackButtons.svelte";
import LanguageSwitcher from "./components/LanguageSwitcher.svelte";
import NavTab from "./components/NavTab.svelte";
import sendFeedback from "./utils/SendFeedback.js";
import uiStore from "./utils/UIStore";

let showFooter = true;
let showMobileMenu = false;

let url = location.pathname;
let feedbackOpen = false;

let currentTab = 0;

let features = {
	chat: true,
	recherche: true,
	askTheText: true,
	summary: true,
};

// quick fix routing
window.setInterval(() => {
	if (url !== location.pathname) {
		url = location.pathname;
		setCurrentTab();
	}
}, 100);

//init Tab number and update after page update
setCurrentTab();

/*afterUpdate(() => {
        console.log("afterUpdate")
        setCurrentTab()
    });*/

let version = null;

function setCurrentTab() {
	if (url === "/") {
		currentTab = 0;
	} else if (url === "/zusammenfassung") {
		currentTab = 2;
	} else if (url === "/faq") {
		currentTab = 4;
	} else if (url === "/chat") {
		currentTab = 5;
	} else if (url === "/recherche") {
		currentTab = 6;
	} else if (url === "/fragdentext") {
		currentTab = 8;
	} else if (
		url === "/datenschutzerklaerung" ||
		url === "/nutzungsbedingungen"
	) {
		currentTab = 7;
	}
}

// terms pop up
const hasAcceptedTOS = () => {
	return localStorage.accepted !== undefined;
};

let showPopup = !hasAcceptedTOS();

const agreeTOS = () => {
	localStorage.accepted = "True";
	showPopup = false;
	releaseNotesViewed();
};

//release Notes Popup
let showReleaseNotesPopup = false;

const hasViewedCurrentRelease = () => {
	return localStorage[version] !== undefined;
};

const releaseNotesViewed = () => {
	localStorage[version] = "viewed";
	showReleaseNotesPopup = false;
};

//load current state from uistore
uiStore.releaseStore.subscribe((store) => {
	version = store.currentVersion;
	showReleaseNotesPopup = !hasViewedCurrentRelease();
});

uiStore.featureStore.subscribe((store) => {
	features = store;
});

const scrollToTop = () => {
	window.scrollTo(0, 0);
};

async function giveFeedback(feedbackText) {
	//Set rating to NEUTRAL and llm_name to "" -> thumbs buttons are not implemented yet for general feedback
	const body = {
		feedback: 2,
		feedback_text: feedbackText,
	};

	sendFeedback(body, `${process.env.API_URL}/feedback/general`);
}

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});
</script>

<LanguageSwitcher />

<Navbar>
  <div class="navbar_tabs" slot="tabs">
    <NavTab
      callback={(tab) => {
        scrollToTop();
        currentTab = tab;
        feedbackOpen = false;
      }}
      {currentTab}
      tab={0}
      name={uiTexts.app.nav.home}
      url="/"
    />
    {#if features.chat}
      <NavTab
        callback={(tab) => {
          scrollToTop();
          currentTab = tab;
          feedbackOpen = false;
        }}
        {currentTab}
        tab={5}
        name={uiTexts.app.nav.chat}
        url="/chat"
      />
    {/if}

    {#if features.recherche}
      <NavTab
        callback={(tab) => {
          scrollToTop();
          currentTab = tab;
          feedbackOpen = false;
        }}
        {currentTab}
        tab={6}
        name={uiTexts.app.nav.research}
        url="/recherche"
      />
    {/if}

    {#if features.askTheText}
      <!--At the moment only directly accessible via the url. Should be controlled later via config settings.-->
      <NavTab
        callback={(tab) => {
          scrollToTop();
          currentTab = tab;
          feedbackOpen = false;
        }}
        {currentTab}
        tab={8}
        name={uiTexts.app.nav.askTheText}
        url="/fragdentext"
      />
    {/if}

    {#if features.summary}
      <NavTab
        callback={(tab) => {
          scrollToTop();
          currentTab = tab;
          feedbackOpen = false;
        }}
        {currentTab}
        tab={2}
        name={uiTexts.app.nav.summary}
        url="/zusammenfassung"
      />
    {/if}

    <NavTab
      callback={(tab) => {
        scrollToTop();
        currentTab = tab;
        feedbackOpen = false;
      }}
      {currentTab}
      tab={4}
      name={uiTexts.app.nav.faq}
      url="/faq"
    />
  </div>
  <!-- /.navbar_tabs -->

  <div class="mobile_menu" slot="menu">
    <button
      aria-label={uiTexts.app.mobileNavAria}
      on:click={() => (showMobileMenu = !showMobileMenu)}
      style="z-index: 100"
    >
      <div class="w-10 h-10">
        {#if showMobileMenu === false}
          <MdMenu />
        {:else}
          <MdClose />
        {/if}
      </div>
    </button>
  </div>
</Navbar>

{#if showMobileMenu === true}
  <div class="fixed right-0 mobile_sidebar">
    <div class="w-full flex flex-col gap-2">
      <div
        class={currentTab === 0 ? "tab selected menu" : "tab menu"}
        on:click={scrollToTop}
        on:click|preventDefault={() => (currentTab = 0)}
        on:click|preventDefault={() => (showMobileMenu = false)}
      >
        <Link
          style={currentTab === 0 ? "color: yellow;" : "color: white"}
          to="/"
        >
          {#if currentTab === 0}
            {uiTexts.app.nav.home}
          {:else}
            {uiTexts.app.nav.home}
          {/if}
        </Link>
      </div>

      {#if features.chat}
        <div
          class={currentTab === 5 ? "tab selected menu" : "tab menu"}
          on:click={scrollToTop}
          on:click|preventDefault={() => (currentTab = 5)}
          on:click|preventDefault={() => (showMobileMenu = false)}
        >
          <Link
            style={currentTab === 5 ? "color: yellow;" : "color: white"}
            to="/chat"
          >
            {#if currentTab === 5}
              <p></p>
              {uiTexts.app.nav.chat}
            {:else}
              {uiTexts.app.nav.chat}
            {/if}
          </Link>
        </div>
      {/if}

      {#if features.recherche}
        <div
          class={currentTab === 6 ? "tab selected menu" : "tab menu"}
          on:click={scrollToTop}
          on:click|preventDefault={() => (currentTab = 6)}
          on:click|preventDefault={() => (showMobileMenu = false)}
        >
          <Link
            style={currentTab === 6 ? "color: yellow;" : "color: white"}
            to="/recherche"
          >
            {#if currentTab === 6}
              <p></p>
              {uiTexts.app.nav.research}
            {:else}
              {uiTexts.app.nav.research}
            {/if}
          </Link>
        </div>
      {/if}

      {#if features.askTheText}
        <div
          class={currentTab === 8 ? "tab selected menu" : "tab menu"}
          on:click={scrollToTop}
          on:click|preventDefault={() => (currentTab = 8)}
          on:click|preventDefault={() => (showMobileMenu = false)}
        >
          <Link
            style={currentTab === 8 ? "color: yellow;" : "color: white"}
            to="/fragdentext"
          >
            {#if currentTab === 8}
              <p></p>
              {uiTexts.app.nav.askTheText}
            {:else}
              {uiTexts.app.nav.askTheText}
            {/if}
          </Link>
        </div>
      {/if}

      {#if features.summary}
        <div
          class={currentTab === 2 ? "tab selected menu" : "tab menu"}
          on:click={scrollToTop}
          on:click|preventDefault={() => (currentTab = 2)}
          on:click|preventDefault={() => (showMobileMenu = false)}
        >
          <Link
            style={currentTab === 2 ? "color: yellow;" : "color: white"}
            to="/zusammenfassung"
          >
            {#if currentTab === 2}
              <p></p>
              {uiTexts.app.nav.summary}
            {:else}
              {uiTexts.app.nav.summary}
            {/if}
          </Link>
        </div>
      {/if}
      <div
        class={currentTab === 4 ? "tab selected menu" : "tab menu"}
        on:click={scrollToTop}
        on:click|preventDefault={() => (currentTab = 4)}
        on:click|preventDefault={() => (showMobileMenu = false)}
      >
        <Link
          style={currentTab === 4 ? "color: yellow;" : "color: white"}
          to="faq"
        >
          <div>{uiTexts.releaseNotesPopup.faqLinkText}</div>
        </Link>
      </div>
    </div>
  </div>
{/if}

{#if url === "/recherche" && features.recherche}
  <RechercheTab></RechercheTab>
{/if}
{#if url === "/fragdentext"}
  <RechercheTab onlyDocuments={true}></RechercheTab>
{/if}

{#if url === "/"}
  <LandingPage />
{/if}

{#if url === "/zusammenfassung" && features.summary}
  <SummaryTab />
{/if}

{#if (url === "/chat") & features.chat}
  <ChatTab />
{/if}

{#if url === "/faq"}
  <FAQ />
{/if}

{#if url === "/nutzungsbedingungen"}
  <TermsOfUse>
    <Link
      to="/datenschutzerklaerung"
      class="policy_and_terms"
      style="font-size: 1rem;"
      >{uiTexts.app.footer.privacy}
    </Link>
  </TermsOfUse>
{/if}

{#if url === "/datenschutzerklaerung"}
  <PrivacyPolicy />
{/if}

{#if !hasAcceptedTOS() && showPopup}
  <Popup {currentTab}
    ><span slot="agree"
      ><button class="confirm" on:click|preventDefault={() => agreeTOS()}
        >{uiTexts.app.agree}</button
      ></span
    ></Popup
  >
{/if}

{#if version != null && hasAcceptedTOS() && !hasViewedCurrentRelease() && showReleaseNotesPopup}
  <PopupReleaseNotes>
    <a
      slot="faq"
      class="textlink"
      style="margin-left:3px; opacity:0.5; font-weight:normal;"
      href="/faq#versionshinweise"
      on:click={() => releaseNotesViewed()}>{uiTexts.app.nav.faq}</a
    >.
    <span slot="agree"
      ><button
        class="confirm"
        on:click|preventDefault={() => releaseNotesViewed()}>{uiTexts.app.close}</button
      ></span
    >
  </PopupReleaseNotes>
{/if}

<div>
  <button
    class={showFooter === true ? "scrollToTop" : "scrollToTop_bottom"}
    on:click={scrollToTop}
  >
    <i class="arrow up" />
    {uiTexts.app.scrollToTop}
  </button>
</div>

{#if showFooter}
  <Footer>
    <div slot="version">
      {#if version != undefined}
        <a
          class="textlink version"
          style="font-weight:normal; color:white; font-size:inherit;"
          href="/faq#versionshinweise">{uiTexts.app.version} {version}</a
        >
      {/if}
    </div>

    <div
      class="row center"
      slot="links"
      style=" position: absolute; left: 50%; transform: translateX(-50%);"
    >
      <div
        on:click|preventDefault={() => {
          feedbackOpen = false;
        }}
        class="flex-center"
      >
        <Link
          to="nutzungsbedingungen"
          style="color: white; font-size: 0.9rem; font-weight: 500; text-decoration: underline"
        >
          <div class="foot_tab">{uiTexts.app.footer.terms}</div>
        </Link>
        <p class="pipe">|</p>
      </div>
      <div
        on:click|preventDefault={() => {
          feedbackOpen = false;
        }}
        class="flex-center"
      >
        <Link
          to="datenschutzerklaerung"
          style="color: white; font-size: 0.9rem; font-weight: 500; text-decoration: underline"
        >
          <div class="foot_tab">{uiTexts.app.footer.privacy}</div>
        </Link>
        <p class="pipe">|</p>
      </div>

      <div class="flex-center">
        <a
          href="https://example.com"
          target="_blank"
          style="color: white; font-size: 0.9rem; font-weight: 500; text-decoration: underline"
          ><div class="foot_tab">{uiTexts.app.footer.externalLink}</div>
        </a>
        <p class="pipe">|</p>
      </div>

      <div class="flex-center">
        <button
          style="color: white; font-size: 0.9rem; font-weight: 500; text-decoration: underline; text-transform:none; text-transform:none; padding:0px;background-color:transparent;border:none;"
          on:click={() => {
            feedbackOpen = true;
          }}
        >
          <div class="foot_tab">{uiTexts.app.footer.feedback}</div>
        </button>
        <p class="pipe">|</p>
      </div>

      <div on:click={() => (feedbackOpen = false)} class="flex-center">
        <Link
          to="faq"
          style="color: white; font-size: 0.9rem; font-weight: 500; text-decoration: underline"
        >
          <div class="foot_tab">{uiTexts.app.nav.faq}</div>
        </Link>
      </div>
    </div>

    <span class="close_icon" slot="close">
      <div class="icon" on:click|preventDefault={() => (showFooter = false)}>
        <IoMdClose />
      </div></span
    >
  </Footer>
{/if}

<FeedbackButtons
  buttonClicked="0"
  bind:feedbackOpen
  showButtons={false}
  callback={(rating, feedback_text) => giveFeedback(feedback_text)}
/>

<Logging error info keepMessageInSeconds={2.5} warning />

<style>
  .mobile_sidebar {
    display: none;
    padding: 100px 10px 10px 10px;
    z-index: 99;
    width: 250px;
    background-color: var(--main-color);
  }

  .tab.menu {
    font-size: 0.9rem;
    background-color: var(--sec-color);
  }

  .tab.menu:hover {
    font-size: 0.9rem !important;
    color: var(--main-color);
  }

  .navbar_tabs {
    justify-content: center;
    display: flex;
    gap: 0;
    margin: auto;
    margin-bottom: 0;
    flex: auto;
  }

  .mobile_menu {
    display: none;
  }

  .icon {
    color: white;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }

  .foot_tab {
    font-size: 1rem;
  }

  .foot_tab:hover {
    color: var(--main-color);
    text-decoration: underline;
  }

  .version:hover {
    color: var(--main-color) !important;
  }

  .flex-center {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .pipe {
    color: white;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 0.9rem;
  }

  .arrow {
    border: solid rgb(0, 0, 0);
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }

  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  .scrollToTop {
    width: fit-content;
    margin-right: 10px;
    font-weight: 600;
    font-family: "MainFont_SemiBold", Arial, Helvetica, sans-serif;
    background-color: transparent !important;
    color: black !important;
    border: none;
    display: flex;
    gap: 5px;
    bottom: 47px;
    right: 0px;
    margin: 0;
    position: fixed;
    z-index: 95;
  }

  .scrollToTop:hover {
    text-decoration: underline !important;
    color: black !important;
    border: none;
  }

  .scrollToTop_bottom {
    width: fit-content;
    margin-right: 10px;
    font-weight: 600;
    font-family: "MainFont_SemiBold", Arial, Helvetica, sans-serif;
    background-color: white !important;
    color: black !important;
    border: none;
    display: flex;
    gap: 5px;
    bottom: 0px;
    right: 0px;
    margin: 0;
    position: fixed;
    z-index: 95;
  }

  .scrollToTop_bottom:hover {
    text-decoration: underline !important;
    background-color: white !important;
    color: black !important;
    border: none;
  }

  p {
    font-size: 16px;
    padding: 0px;
    font-weight: 500;
  }

  @media screen and (max-width: 1144px) {
    .foot_tab {
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 700px) {
    .scrollToTop {
      width: fit-content;
      margin-right: 10px;
      background-color: white !important;
      color: black !important;
      border: none;
      display: flex;
      gap: 5px;
      bottom: 0px;
      right: -110px;
      margin: 0;
      position: fixed;
      z-index: 100;
    }

    .tab,
    .selected {
      width: fit-content;
    }
  }

  @media screen and (max-width: 1500px) {
    .navbar_tabs {
      gap: 10px;
      justify-content: center;
    }
  }

  @media screen and (max-width: 1208px) {
    .navbar_tabs {
      display: none;
    }

    .mobile_menu {
      display: block;
    }

    .mobile_sidebar {
      display: flex;
    }
  }
</style>
